import {gql} from "@apollo/client";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";


const GRAPHQL_MUTATION = gql`
mutation submitFsoInquiryByProvider($inquiry: String!) {
    submitFsoInquiryByProvider(inquiry: $inquiry) {
        guid
    }
}`;

export function useSubmitFsoInquiryByProvider() {
    const {execute,} = useMutation$<{ inquiry: string }, void>(GRAPHQL_MUTATION);
    const submitFsoInquiryByProvider = useCallback(async function (inquiry: string | null) {
        if (inquiry == null) {
            return;
        }

        try {
            await execute({
                variables: {
                    inquiry,
                }
            });
            showToast.success('FSO Inquiry successfully submitted. The Request can be tracked in the “Submitted Requests” section and a request number ID will be available shortly');
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit FSO Inquiry: ${errors.message || errors[0].message}`);
            }
        }
    }, [execute]);

    return {
        submitFsoInquiryByProvider
    }
}
